module.exports = __webpack_public_path__ + "amcharts/images/lens.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lens.svg
// module id = 271
// module chunks = 0